var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Invoicing")]),_c('ul',[_c('li',[_vm._v("Write invoice (email, PDF)")]),_c('li',[_vm._v("Based on products and inventory")]),_c('li',[_vm._v("Free content invoice")])])])
}]

export { render, staticRenderFns }